import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SearchModel, SearchResultModel } from 'src/common/components';
import { TaskDetailModel, TaskModel, TaskSaveModel } from './tasks.model';

@Injectable()
export class TaskService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<TaskModel>> {
    return this.http.post<SearchResultModel<TaskModel>>(`${environment.apiUrl}/Tasks/Search`, search).toPromise();
  }

  delete(id: number): Promise<void> {
    return this.http.delete<void>(`${environment.apiUrl}/Tasks/Delete/${id}`).toPromise();
  }

  getDetail(id: number): Promise<TaskDetailModel> {
    return this.http.get<TaskDetailModel>(`${environment.apiUrl}/Tasks/Details/${id}`).toPromise();
  }

  save(model: TaskSaveModel): Promise<void> {
    return this.http.post<void>(`${environment.apiUrl}/Tasks/Save`, model).toPromise();
  }

  searchSelectOpnProjectDeadlinesList(search: SearchModel, id: number): Promise<SearchResultModel<TaskModel>> {
    return this.http.post<SearchResultModel<TaskModel>>(`${environment.apiUrl}/Tasks/SearchSelectOpnProjectDeadlinesList/${id}`, search).toPromise();
  }
}
